/**
 * Represents print attribute configuration options
 */
export interface PrintAttributeOptions {
  label: string;
  value: string;
  order?: number;
}

/**
 * Represents the detail section of a print attribute
 */
export interface PrintAttributeDetail {
  Id?: string;
  ClientKey?: string;
  UserId?: string;
  PrintAttributeName?: string;
  PrintAttributeType?: string;
  Description?: string;
  Status?: string;
  LogicalVersions?: string[];
  LogicalPrintPage?: string;
  CreatedAt?: string;
  EventOnlyAttribute?: boolean;
}

/**
 * Request body for create/update PrintAttribute (matches API contract).
 * Top-level and Detail must contain only these properties.
 */
export interface PrintAttributeSavePayload {
  Detail: {
    Id: string;
    ClientKey: string;
    UserId: string;
    PrintAttributeName: string;
    PrintAttributeType: string;
    Description: string;
    Status: string;
    LogicalVersions: string[];
    LogicalPrintPage: string;
    CreatedAt: string;
    EventOnlyAttribute: boolean;
  };
  DivisionIds: string[];
  DivisionNames: string;
  EventTypeName?: string;
  BannerName: string;
  EventTypeId: string;
  BannerId: string;
  AssetId?: string;
  Data: any;
}

/**
 * Represents a complete print attribute definition with all related data
 */
export interface PrintAttributeDefinition {
  DomainId?: string;
  /** Event association payload from APIs; may appear at root or under {@link PrintAttributeDetail.Data}. */
  Detail?: PrintAttributeDetail;
  DivisionIds?: string[];
  DivisionNames?: string;
  EventTypeName?: string;
  BannerName?: string;
  AssetName?: string;
  EventTypeId?: string;
  BannerId?: string;
  AssetId?: string;
  // Legacy fields for backward compatibility
  PrintAttributeType?: PrintAttributeType;
  Data: any;
  CreatedAt?: string;
  AssetData?: AssetData;
}

export interface AssetData {
  AssetId: string;
  AssetName: string;
  FileName: string;
  FileUrl: string;
  FileType: string;
  InValidFileUrl: string | null;
  Captions: {
    FileUrl: string;
    LanguageDisplayName: string;
    Language: string;
  }[];
}

/**
 * Supported print attribute types
 */
export enum PrintAttributeType {
  address = 'address',
  sale_dates = 'sale_dates',
  url = 'url',
  printer_code = 'Printer Code',
  header = 'header',
  creative = 'creative',
  market_place = 'market_place',
  offer_event = 'offer_event',
  abev = 'abev',
  dry_version = 'dry_version',
}

/**
 * Print attribute status
 */
export enum PrintAttributeStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export enum PrintVertexTypes {
  Event = 'Event',
  Offer = 'Offer',
  Promo = 'Promo',
  Product = 'Product',
  Asset = 'Asset',
}
